import request from '@/api/request'

/** 查询竞赛查询列表 */
export function listCompetitionQuery(data) {
  return request({
    url: '/competition/competitionQuery/user/list',
    method: 'post',
    data: data
  })
}
